import { ReactHTMLElement, ReactNode } from 'react'

import UploadIcon from 'app/assets/icons/paperclip.svg'
import Box, { BoxProps } from 'app/components/base/Box'
import Stack from 'app/components/base/Stack'

export interface UploadReportInputProps extends BoxProps {
  children: ReactNode
  inputProps: ReactHTMLElement<HTMLInputElement>
}

const UploadReportInput = ({
  children,
  inputProps,
  sx,
  ...rest
}: UploadReportInputProps) => {
  return (
    <Box
      {...rest}
      sx={{
        py: 2.5,
        px: 0,
        maxHeight: 100,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        backgroundColor: 'background.grey',
        border: '1px solid',
        borderColor: 'stroke.main',
        borderRadius: '8px',
        cursor: 'pointer',
        ...sx
      }}
    >
      <input data-testid="uploadFile" {...inputProps} />

      <Stack
        direction="row"
        spacing={1.5}
        sx={{ width: '100%', alignItems: 'center', justifyContent: 'center' }}
      >
        <UploadIcon />

        <>{children}</>
      </Stack>
    </Box>
  )
}

export default UploadReportInput
